export const appState = {
    authToken: null,
}